// extracted by mini-css-extract-plugin
export default {"randomTileTitle":"RandomTile_randomTileTitle__0gXmu","randomTile":"RandomTile_randomTile__tDofx","randomTileImg":"RandomTile_randomTileImg__L9wm5"};